// 外部記事コンテンツ（データ基盤 ＞ 外部記事コンテンツ）。
// 特集ページマスタに載らない記事ページ（ページ管理機能の静的ページ・別ドメインのオウンドメディア等）
// を取り込み、特集ページと同じ構造で持つ。Media-Driver・記事レコメンド・Findee・AIタグが
// 特集ページと併せて使う。取り込みは閲覧トリガで、実際のページ取得はサーバ側のワーカーが5分おきに行う。

export const ExternalArticleApiPath = {
  LIST: '/api/sites/{site_id}/external-articles', // GET 一覧
  DETAIL: '/api/sites/{site_id}/external-articles/{article_pk}', // GET 詳細 / DELETE 削除
  BULK: '/api/sites/{site_id}/external-articles/bulk', // POST 一括投入
  REFETCH: '/api/sites/{site_id}/external-articles/{article_pk}/refetch', // POST 1件再取込
  REFETCH_ALL: '/api/sites/{site_id}/external-articles/refetch-all', // POST 全件再取込
  SETTINGS: '/api/sites/{site_id}/external-articles-settings' // GET 設定 / PUT 保存
}

// 記事の状態。レコメンド対象は OK だけ
export const ExternalArticleStatus = {
  PENDING: 'pending', // 取得待ち
  OK: 'ok', // 取得・抽出に成功。レコメンド対象
  EXCLUDED: 'excluded', // 取込除外マーカーが付いている
  MISSING: 'missing' // 取得できない（4xx・エラーページ・抽出失敗）
} as const
export type ExternalArticleStatus =
  (typeof ExternalArticleStatus)[keyof typeof ExternalArticleStatus]

export interface SiteIdVars {
  site_id: number
}

export interface ExternalArticle {
  id: number
  article_id: string // 記事ID（ホスト付きパターンなら `ホスト/ID`）
  article_key: string // 記事キー（`x:`+記事ID）。計測・AIタグ・ベクトルの識別子
  url: string
  source_host: string // 取得元ドメイン
  title: string
  html_page_title: string
  metadata_desc: string
  image_url: string
  publish: string // PUBLIC / PRIVATE
  status: ExternalArticleStatus
  status_label: string
  fail_reason: string | null
  published_at: string | null
  last_fetched_at: string | null
  view_count: number
  body_preview?: string | null
  body_length?: number | null
}

export interface ListExternalArticleVars extends SiteIdVars {
  status?: ExternalArticleStatus | ''
  host?: string
  q?: string
  limit?: number
  offset?: number
}

export interface ListExternalArticleResponse {
  items: ExternalArticle[]
  total: number
  counts: Record<string, number>
  pending: number
  hosts: string[] // 取得元ドメインの一覧（絞り込み用）
}

export interface DetailVars extends SiteIdVars {
  article_pk: number
}

export interface BulkVars extends SiteIdVars {
  urls: string
}

export interface BulkRejected {
  url: string
  reason: string
}

export interface BulkResponse {
  accepted: number
  duplicated: number
  rejected: number
  rejected_items: BulkRejected[]
  pending: number
}

export interface RefetchResponse {
  requeued: number
  pending: number
}

export interface ExternalArticleSettings {
  enabled: boolean
  url_patterns: string
  body_selector: string
  exclude_marker: string
  error_text: string
  basic_user: string
  basic_pass_set: boolean
}

// basic_pass は未指定＝変更なし、空文字＝消去。
// 未入力と消去を同じ値で表すと、設定済みのパスワードを画面から消せなくなる
export interface UpdateSettingsVars extends SiteIdVars {
  enabled?: boolean
  url_patterns?: string
  body_selector?: string
  exclude_marker?: string
  error_text?: string
  basic_user?: string
  basic_pass?: string
}

export interface DeletedResponse {
  deleted: boolean
}
